MPP.Modal =

  open: (selector) ->
    $modal = $ selector
    GIG.Modal.open { el: $modal }

  openOnClick: (clickSelector, modalSelector) ->
    $click = $ clickSelector
    $modal =  $ modalSelector
    $click.on 'click', (event) ->
      event.preventDefault()
      MPP.Modal.open $modal

$ ->

  # Enable History for Modals on mobile devices

  return unless Modernizr.mq('(max-width: 767px)') and window.history?.pushState?

  doNotSaveInHistory = false

  $('body').on 'modal-open', (event, { id }) ->
    if doNotSaveInHistory
      doNotSaveInHistory = false
      return

    url = window.location.href.replace /#.+$/, ''
    history.pushState { openModal: id }, document.title, url

  GIG.Modal.onClose (id) ->
    if doNotSaveInHistory
      doNotSaveInHistory = false
      return

    url = window.location.href.replace /#.+$/, ''
    history.pushState { closeModal: id }, document.title, url

  $(window).on 'popstate', ({ originalEvent }) ->
    state = originalEvent.state

    if state?.openModal?
      doNotSaveInHistory = true
      MPP.Modal.open "##{state.openModal}"
    else if state?.closeModal? or state is null
      doNotSaveInHistory = true
      GIG.Modal.close()
